import Header from "components/Headers/Header";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";

import {
  Button,
  CardImg,
  Collapse,
  Container,
  CustomInput,
  Modal,
  ModalBody,
  Table,
} from "reactstrap";
import { getAllTeamRosters, deleteTeam } from "store/actions/TeamRosterAction";
import { getAthletes } from "store/actions/athleteAction";
import { toast } from "react-toastify";

const TeamRoster = () => {
  const [removeTeam, setRemoveTeam] = useState(false); //Modal Open For removeteam

  const [removeTeamID, setRemoveTeamID] = useState(""); // For DeleteteamID

  const dispatch = useDispatch();
  const { teamrosterData } = useSelector((state) => state.teamrosters);

  const { athletes } = useSelector((state) => state.athlete);
  const [sortBy, setSortBy] = useState("institute_name");

  const [active, setActive] = useState(-1);

  const getPlayerName = (ID) => {
    var obj =
      athletes &&
      athletes.find((ele) => {
        return ele.id === ID;
      });
    if (obj) {
      return obj.first_name + " " + obj.last_name;
    } else {
      return "N/A";
    }
  };

  const getplayerImage = (ID) => {
    var obj =
      athletes &&
      athletes.find((ele) => {
        return ele.id === ID;
      });
    if (obj) {
      return obj.player_image?.url;
    } else {
      return "N/A";
    }
  };

  const handleCollapseIcon = (id) => {
    if (active == id) {
      setActive(-1);
    } else {
      setActive(id);
    }
  };

  const onChangeDeleteTeam = (id) => {
    setRemoveTeam(true);
    setRemoveTeamID(id);
  };

  const handleRemoveTeam = () => {
    setRemoveTeam(!removeTeam);
  };

  const handleDeleteTeam = () => {
    dispatch(deleteTeam(removeTeamID));
    setRemoveTeam(false);
    toast.success("Team Delete Successfully");
  };

  useEffect(() => {
    if (teamrosterData.length === 0) {
      dispatch(getAllTeamRosters(sortBy));
    }
  }, []);

  useEffect(() => {
    dispatch(getAllTeamRosters(sortBy));
  }, [sortBy]);

  useEffect(() => {
    if (athletes.length === 0) {
      dispatch(getAthletes());
    }
  }, []);

  return (
    <>
      <Header />
      <Container className="mt--4" fluid>
        <div className="d-flex mt-3 justify-content-between align-items-center">
          <p className="text-dark auth-desc-subtitle ml-0 mb-0 mt-2">
            Team Roster
          </p>
          <div className="" style={{ width: "200px" }}>
            <label>Sort By :</label>
            <select
              className="cars mb-3 form-control"
              value={sortBy}
              onChange={(e) => setSortBy(e.target.value)}
            >
              <option value="institute_name">Alphabetically</option>
              <option value="updatedAt">Last updated</option>
            </select>
          </div>
        </div>

        <div className="team-roster-list">
          {teamrosterData && teamrosterData.length > 0 ? (
            teamrosterData.map((item, idx) => {
              return (
                <>
                  <div
                    className="mb-1 rosterCollapse d-flex justify-content-between align-items-center"
                    style={{
                      width: "100%",
                    }}
                  >
                    <div
                      onClick={() => handleCollapseIcon(idx)}
                      style={{ flexBasis: "20%" }}
                    >
                      {item.institute_name}
                    </div>
                    <div className="text-center">
                      <div className="mr-5 text-center">
                        <div
                          className="m-0"
                          style={{
                            fontweight: "bold",
                          }}
                        >
                          Team Id
                        </div>
                        <div className="m-0">{item.teamID}</div>
                      </div>
                    </div>
                    <div className="text-center">
                      <div className="mr-5 text-center">
                        <div
                          className="m-0"
                          style={{
                            fontweight: "bold",
                          }}
                        >
                          Sport
                        </div>
                        <div className="m-0">{item.sport}</div>
                      </div>
                    </div>
                    <div className="text-center">
                      <div className="mr-5 text-center">
                        <div
                          className="m-0"
                          style={{
                            fontweight: "bold",
                          }}
                        >
                          Gender
                        </div>
                        <div className="m-0">{item.gender}</div>
                      </div>
                    </div>

                    <div className="d-flex align-items-center">
                      <div className="mr-5 text-center">
                        <div
                          className="m-0"
                          style={{
                            fontweight: "bold",
                          }}
                        >
                          Last Updated
                        </div>
                        <div className="m-0">
                          {moment
                            .unix(item.updatedAt.seconds)
                            .format("DD MMM YYYY")}
                        </div>
                      </div>
                      <div className="mr-5">
                        <i
                          style={{
                            cursor: "pointer",
                          }}
                          onClick={() => {
                            onChangeDeleteTeam(item.id);
                          }}
                          className="fas fa-trash fa-lg"
                        ></i>
                      </div>
                      <div onClick={() => handleCollapseIcon(idx)}>
                        {active == idx ? (
                          <i class="fas fa-angle-up fa-2x"></i>
                        ) : (
                          <i class="fas fa-angle-down fa-2x"></i>
                        )}
                      </div>
                    </div>
                  </div>
                  <hr style={{ margin: 0 }} />

                  <Collapse isOpen={active == idx}>
                    {item.roster_team.length > 0 ? (
                      <Table striped responsive>
                        <thead>
                          <tr>
                            <th>
                              <h5>Images</h5>
                            </th>
                            <th>
                              <h5>Name</h5>
                            </th>
                            <th>
                              <h5>position</h5>
                            </th>
                            <th>
                              <h5>Starter</h5>
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          {item.roster_team.map((ele, index) => {
                            return (
                              <tr>
                                <td>
                                  <CardImg
                                    className="rosterListImg"
                                    alt="Card image cap"
                                    src={getplayerImage(ele.id)}
                                  />
                                </td>
                                <td>{getPlayerName(ele.id)}</td>
                                <td>{ele.position}</td>
                                <td>
                                  <CustomInput
                                    className="mb-2 mt-1 ml-2"
                                    type="switch"
                                    size="sm"
                                    checked={ele.starter}
                                  />
                                </td>
                              </tr>
                            );
                          })}
                        </tbody>
                      </Table>
                    ) : (
                      <h4 className="text-center mt-2">
                        <>
                          No Player Available,Do You Want To{" "}
                          <span
                            onClick={() => {
                              onChangeDeleteTeam(item.id);
                            }}
                            className="removeLink"
                          >
                            Remove Team
                          </span>
                          ?
                        </>
                      </h4>
                    )}
                  </Collapse>
                </>
              );
            })
          ) : (
            <h2 className="text-center" style={{ color: "black" }}>
              No Team Found
            </h2>
          )}
        </div>
        <Modal isOpen={removeTeam} toggle={handleRemoveTeam} centered>
          <ModalBody>
            <div className="d-flex justify-content-end">
              <div>
                <i onClick={handleRemoveTeam} class="fas fa-times"></i>
              </div>
            </div>
            <div>
              <h2>
                Are You Sure You Want To Delete This Team Permanently From The
                List?
              </h2>
            </div>

            <div className="d-flex mt-4 justify-content-end">
              <Button color="primary" onClick={handleDeleteTeam}>
                Yes
              </Button>{" "}
              <Button color="secondary" onClick={handleRemoveTeam}>
                Cancel
              </Button>
            </div>
          </ModalBody>
        </Modal>
      </Container>
    </>
  );
};

export default TeamRoster;
